import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6e309hxy0g: FaireBrandEntity = {
  token: "b_6e309hxy0g",
  type: "brand",
  name: "BCmini",
  avatarUrl:
    "https://cdn.faire.com/fastly/f97602edffdcad1cecd77d97ab89b59bb65302c41c89957f7296bd0a9c43c924.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0ccca02abab3ded48ca3508364e2778dff9ebe3351717d0c02f9d42b0967576d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f97602edffdcad1cecd77d97ab89b59bb65302c41c89957f7296bd0a9c43c924.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0ccca02abab3ded48ca3508364e2778dff9ebe3351717d0c02f9d42b0967576d.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 95,
  rating: 4.9,
  reviewCount: 222,
  isInsider: true,
  description:
    "Visit BCMINI.COM to View our Full Catalog of Products. \n\nFaire Restricts ordering Multiple Sets of Products; Place Full order on BCmini.com. \n\nContact [redacted-email] for assistance. \n\nBCmini Importer & Wholesale Distributor of Japanese Products, Family Owned and Operated since 1977.\nOfficial wholesale distributor Japanese Stationary, IWAKO Erasers, & Toys.\n\nWide Selection of Japanese Miniatures, Pens, Plush, Stickers and more! ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:18.890Z",
    importedBy: "entity-db-cli",
  },
};
